module.exports = __webpack_public_path__ + "static/media/Knob4.3db16771.png";